export const CashFlowData = [
  {
    id:"1",
    Date: "24 Dec 2024",
    Bank_Account: "HBSC - 3298784309485",
    Description: "Cash receipts from sales",
    Credit: "$1000",
    Debit: "$0.00",
    Account_balance: "$1000",
    Total_Balance: "$889898",
    Payment_Method: "Stripe",
  },
  {
    id:"2",
    Date: "10 Dec 2024",
    Bank_Account: "SWIZ - 5475878970090",
    Description: "Cash payments to employees",
    Credit: "$0.00",
    Debit: "$1500",
    Account_balance: "$1500",
    Total_Balance: "$9899",
    Payment_Method: "Paypal",
  },
  {
    id:"3",
    Date: "27 Nov 2024",
    Bank_Account: "SWIZ - 3255465758698",
    Description: "Purchase of POS equipment",
    Credit: "$1800",
    Debit: "$0.00",
    Account_balance: "$1800",
    Total_Balance: "$35656",
    Payment_Method: "Cash",
  },
  {
    id:"4",
    Date: "18 Nov 2024",
    Bank_Account: "IBO - 4353689870544",
    Description: "Sale of old equipment",
    Credit: "$1000",
    Debit: "$1000",
    Account_balance: "$1000",
    Total_Balance: "$1562",
    Payment_Method: "Paypal",
  },
  {
    id:"5",
    Date: "06 Nov 2024",
    Bank_Account: "NBC - 4324356677889",
    Description: "Loan received (short-term)",
    Credit: "$800",
    Debit: "$0.00",
    Account_balance: "$800",
    Total_Balance: "$6896",
    Payment_Method: "Cash",
  },
  {
    id:"6",
    Date: "25 Oct 2024",
    Bank_Account: "NBC - 2343547586900",
    Description: "Repayment of long-term loan",
    Credit: "$0.00",
    Debit: "$750",
    Account_balance: "$0.00",
    Total_Balance: "$8963",
    Payment_Method: "Cash",
  },
  {
    id:"7",
    Date: "14 Oct 2024",
    Bank_Account: "IBO - 3453647664889",
    Description: "Owner’s equity contribution",
    Credit: "$1300",
    Debit: "$0.00",
    Account_balance: "$1300",
    Total_Balance: "$4568",
    Payment_Method: "Paypal",
  },
  {
    id:"8",
    Date: "03 Oct 2024",
    Bank_Account: "SWIZ - 3354456565687",
    Description: "Cash payments for operating",
    Credit: "$1100",
    Debit: "$0.00",
    Account_balance: "$1100",
    Total_Balance: "$5899",
    Payment_Method: "Stripe",
  },
  {
    id:"9",
    Date: "20 Sep 2024",
    Bank_Account: "SWIZ - 3456565767787",
    Description: "Cash payments to suppliers",
    Credit: "$2300",
    Debit: "$0.00",
    Account_balance: "$2300",
    Total_Balance: "$4568",
    Payment_Method: "Stripe",
  },
  {
    id:"10",
    Date: "10 Sep 2024",
    Bank_Account: "IBO - 3434565776768",
    Description: "Cash receipts from sales",
    Credit: "$1700",
    Debit: "$0.00",
    Account_balance: "$1700",
    Total_Balance: "$4568",
    Payment_Method: "Cash",
  },
];
